import React from "react";

function CancellationMessage() {
  return (
    <div className="mt-4">
      <p className="font-semibold">
        Free cancellation up to 12 hours before delivery.
      </p>
      <p className="text-sm">Get a full refund if you change your mind.</p>
    </div>
  );
}

export default CancellationMessage;
